import React from "react";
import '@aws-amplify/ui-react/styles.css';
import { identityFrontUrl, statusError, urlAmazon } from "../config/config";
import {
    Image,
    useTheme,
    Button,
    ButtonGroup,
    Flex,
    View,
} from '@aws-amplify/ui-react';

import { backgroundColor } from "../config/config";
import MessageComponent from "./Message";

function ReferenceImage({ faceLivenessAnalysis , tryagain }) {
    const { tokens } = useTheme();
    const url = new URL(document.URL);
    const pathName = url.pathname.split("/").join("");
    const message  = faceLivenessAnalysis?.callbackResponse?.message?.principalMessage;
    const noRetry = faceLivenessAnalysis?.callbackResponse?.message?.noRetry;
    return (
        <>
          <Flex
            direction="row"
            justifyContent="center"
            alignItems="center"
            alignContent="flex-start"
            wrap="nowrap"
            gap="1rem"
            display={"flex !important"}
          >
            <View
              as="div"
              maxHeight="600px"
              height="600px"
              width="740px"
              maxWidth="740px"
              justifyContent="center"
              alignItems="center"
              className="view-referece"
            >
              {
                faceLivenessAnalysis && faceLivenessAnalysis.callbackResponse.status === statusError && 
                <MessageComponent body={message || 'La captura no pasó la validación, debes intentarlo nuevamente'} type={'warning'} />
              }

              {
                faceLivenessAnalysis && faceLivenessAnalysis.callbackResponse.status !== statusError && 
                <MessageComponent body={'La captura fue realizada correctamente'} type={'success'} />
              }
              { faceLivenessAnalysis?.ReferenceImage?.S3Object &&
                  <Image
                    className="img-reference"
                    src={ urlAmazon + faceLivenessAnalysis.ReferenceImage.S3Object.Bucket + "/" + faceLivenessAnalysis.ReferenceImage.S3Object.Name }
                    objectFit="cover"
                    objectPosition="50% 50%"
                    marginLeft={'auto !important'}
                    marginRight={'auto !important'}
                    width={'95%'}
                    position={'relative'}
                  />
              }
              {!noRetry &&
              <ButtonGroup justifyContent="center">
                {
                  faceLivenessAnalysis && faceLivenessAnalysis.callbackResponse.status === statusError ? (
                  	<Button className="reference-button" backgroundColor={backgroundColor} onClick={tryagain}  isFullWidth={true} marginBottom={tokens.space.large} >
                			Volver a intentar
                  	</Button>
						  		) : (
                  	<Button className="reference-button" backgroundColor={backgroundColor} onClick={() => { window.location.href=`${identityFrontUrl}${pathName}?advanceStep=${pathName}`}}  isFullWidth={true} marginBottom={tokens.space.large} >
                  	  Continuar
                		</Button> 
						  		)
                }
              </ButtonGroup>
              }
            </View>
          </Flex>
        </>
    );
}

export default ReferenceImage;
